import publicApi from './base/userExternalApi';
import api from './base/standardApi';

export default {

  loginUser( data: { email: string, password: string } ) {
    return publicApi.post( 'api/authentication/login', data );
  },

  ssoLogin( data: { identifier: string, deviceId: string, lang: string } ) {
    return api.post( 'api/authentication/sso/login', data );
  },

  ssoConfirm( data: { identifier: string, deviceId: string, otpCode: string } ) {
    return api.post( 'api/authentication/sso/confirm', data );
  },

  ssoRefresh( data: { refreshToken: string } ) {
    return api.post( 'api/authentication/sso/refresh', data );
  },

  ssoLogout( data: { accessToken: string, revokeAll: boolean } ) {
    return api.post( 'api/authentication/sso/logout', data );
  },

  forgotPassword( data: { email: string } ) {
    return publicApi.post( 'api/authentication/forgotpassword', data );
  },

  recoverPassword( data: { token: string, password: string, confirmPassword: string } ) {
    return publicApi.post( 'api/authentication/resetpassword', data );
  },

  changePasswordByAdmin( data: { userId: number, password: string, confirmPassword: string } ) {
    return api.post( 'api/authentication/changePasswordBO', data );
  },

  getTokenImpersonate( params:any ) {
    return api.post( 'api/authentication/impersonate', params );
  },

  getApiVersion() {
    return publicApi.get( 'api/getApiVersion' );
  },
};
